export class ModalManager {


    private static textModalHtml =
        `<div class="modal__dialog">
            <div class="modal__content">
                <h4 id="modal_title" class="mt-none"></h4>
                <p id="modal_text"></p>
                <i class="fas fa-times modal__close"></i>
                <button id="modal_button" class="btn btn--primary"></button>
            </div>
        </div>`;



    public static showModal(title:string, text:string, buttonText:string, buttonClick?: () => void, hideCancelButton : boolean = false) {
        var modalContainer = $(document.createElement("div"));
        modalContainer.html(this.textModalHtml);
        modalContainer.addClass('modal');

        modalContainer.find('#modal_title').html(title);
        modalContainer.find('#modal_text').html(text);
        modalContainer.find('#modal_button').html(buttonText);
        modalContainer.find('#modal_button').click(() => { 
            modalContainer.css("display", "none"); 
            if(buttonClick !== undefined) {
                buttonClick();
            }
        });

        if(hideCancelButton) {
            modalContainer.find('.modal__close').remove();
        }
        else {
            modalContainer.find('.modal__close').click(() => { 
                modalContainer.remove(); 
            });
        }

        modalContainer.css("display", "block");

        $('body').append(modalContainer);

        modalContainer.addClass('show');
    }

    public static loadModal(url:string, centerModal:boolean, afterLoad:(modalContainer: JQuery<HTMLDivElement>) => void) {
        var modalContainer = $(document.createElement("div"));
        modalContainer.attr('id', 'multi-functional-modal-container');
        modalContainer.addClass('modal');

        modalContainer.addClass('fade');
        modalContainer.attr('tabindex', '-1');
        modalContainer.attr('role', 'dialog');
        $('body').append(modalContainer);

        modalContainer.load(url, () => {
            modalContainer.find('.modal__close').click(() => { 
                modalContainer.remove(); 
            });

            afterLoad(modalContainer);

            if(centerModal) {
                modalContainer.addClass('modal-center'); 
            }
            else {
                modalContainer.css("display", "block");
            }

            modalContainer.addClass('show');
        })
    }
}